import { render, staticRenderFns } from "./patrolDetailAppr.vue?vue&type=template&id=1c8c2763"
import script from "./patrolDetailAppr.vue?vue&type=script&lang=js"
export * from "./patrolDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c8c2763')) {
      api.createRecord('1c8c2763', component.options)
    } else {
      api.reload('1c8c2763', component.options)
    }
    module.hot.accept("./patrolDetailAppr.vue?vue&type=template&id=1c8c2763", function () {
      api.rerender('1c8c2763', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sai/patrol/patrolDetailAppr.vue"
export default component.exports